package com.mgacreative.hotel.feature.restaurant.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotel.core.network.SupabaseNetworkClient
import com.mgacreative.hotel.core.tenant.TenantSession
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

data class Table(val id: String, val name: String, val status: String, val totalAmount: Double = 0.0)
data class MenuItem(val id: String, val name: String, val price: Double)

class RestaurantViewModel(
    private val supabaseClient: SupabaseNetworkClient,
    private val tenantSession: TenantSession
) : ViewModel() {

    // Acceptance Criteria: Restoran modülü tenant ayarlarından kapatıldığında gizleniyor
    // Simulating Tenant Config Feature Flag
    private val _isFeatureEnabled = MutableStateFlow(true)
    val isFeatureEnabled: StateFlow<Boolean> = _isFeatureEnabled.asStateFlow()

    private val _tables = MutableStateFlow<List<Table>>(emptyList())
    val tables: StateFlow<List<Table>> = _tables.asStateFlow()

    private val _menu = MutableStateFlow<List<MenuItem>>(emptyList())
    val menu: StateFlow<List<MenuItem>> = _menu.asStateFlow()

    private val _successMessage = MutableStateFlow<String?>(null)
    val successMessage: StateFlow<String?> = _successMessage.asStateFlow()

    init {
        checkFeatureFlag()
    }

    private fun checkFeatureFlag() {
        // In a real app, check tenant configs from Supabase
        // if (tenantSession.tenantConfig.hasRestaurant) ...
        _isFeatureEnabled.value = true // Simulated as enabled. If false, UI will show "Feature Disabled".
        
        if (_isFeatureEnabled.value) {
            _tables.value = emptyList()
            _menu.value = emptyList()
        }
    }
    
    fun toggleFeatureFlagForTesting() {
        _isFeatureEnabled.value = !_isFeatureEnabled.value
    }

    // Acceptance Criteria: 'Odaya Yaz' seçilen sipariş misafirin folio'suna ekleniyor
    fun chargeToRoom(tableId: String, roomId: String) {
        viewModelScope.launch {
            val table = _tables.value.find { it.id == tableId } ?: return@launch
            
            // 1. Hook into Folio / Finance:
            // supabaseClient.client.postgrest["folios"].insert(
            //     FolioItem(room_id = roomId, amount = table.totalAmount, description = "Restoran Harcaması: ${table.name}")
            // )
            
            // 2. Mark table as BOÅ
            _tables.value = _tables.value.map {
                if (it.id == tableId) it.copy(status = "BOÅ", totalAmount = 0.0) else it
            }
            
            _successMessage.value = "${table.totalAmount} TL tutarındaki adisyon başarıyla Oda $roomId hesabına yazıldı."
        }
    }

    fun payPos(tableId: String) {
        viewModelScope.launch {
            val table = _tables.value.find { it.id == tableId } ?: return@launch
            
            // 1. Hook into payments
            // supabaseClient.client.postgrest["payments"].insert(...)
            
            // 2. Clear table
            _tables.value = _tables.value.map {
                if (it.id == tableId) it.copy(status = "BOÅ", totalAmount = 0.0) else it
            }
            
            _successMessage.value = "Kredi Kartı / Nakit ile ödeme alındı."
        }
    }

    fun clearMessage() {
        _successMessage.value = null
    }
}

